import { Component, Input, OnChanges } from "@angular/core";

type ActivityFilter = "ALL" | "BUYER" | "OWNER";

/**
 * Tab "Atividade" da visão 360º: a lista de `LeadHistory` do contacto que o
 * antigo modal "Histórico" mostrava. Um único `*ngFor` sobre `filteredItems`
 * (o markup estava triplicado, um bloco por pill).
 */
@Component({
  selector: "app-contact-overview-activity",
  templateUrl: "./contact-overview-activity.component.html",
})
export class ContactOverviewActivityComponent implements OnChanges {
  @Input() items: any[] = [];
  @Input() loading = false;

  filter: ActivityFilter = "ALL";
  filteredItems: any[] = [];

  ngOnChanges(): void {
    this.applyFilter();
  }

  setFilter(filter: ActivityFilter): void {
    this.filter = filter;
    this.applyFilter();
  }

  private applyFilter(): void {
    const items = this.items ?? [];
    this.filteredItems =
      this.filter === "ALL"
        ? items
        : items.filter((item) => item.lead?.leadType === this.filter);
  }

  formatDateWithHour(date: any): string {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    const hours = String(d.getHours()).padStart(2, "0");
    const minutes = String(d.getMinutes()).padStart(2, "0");
    return `${day}-${month}-${year} ${hours}:${minutes}`;
  }

  getMoveTitle(title: any): string {
    switch (title) {
      case "AutoWon":
        return "t-leads-m.t-moved-to-won";
      case "AutoLost":
        return "t-leads-m.t-moved-to-lost";
      case "AutoUnmarkWon":
        return "t-leads-m.t-moved-unmark-won";
      case "AutoUnmarkLost":
        return "t-leads-m.t-moved-unmark-lost";
      case "AutoDealConverted":
        return "t-leads-m.t-moved-deal-converted";
      default:
        return "t-leads-m.t-moved-to";
    }
  }
}
